import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.logos-slider.slide-logos').length) {
    return;
  }

  new Swiper('.logos-slider.slide-logos .logos-slider__list-logos', {
    slidesPerView: 3,
    loop: true,
    dots: false,
    navigation: {
      prevEl: '.logos-slider-prev-button',
      nextEl: '.logos-slider-next-button',
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
      },
      1199: {
        slidesPerView: 2,
      },      
    },
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/logos-slider.js